import { render } from "./YcomNewtip.vue?vue&type=template&id=3b67ad9a&scoped=true"
import script from "./YcomNewtip.vue?vue&type=script&lang=js"
export * from "./YcomNewtip.vue?vue&type=script&lang=js"

import "./YcomNewtip.vue?vue&type=style&index=0&id=3b67ad9a&scoped=true&lang=css"

import exportComponent from "D:\\A-daima\\前端\\前台\\前台\\nonferrous_metals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b67ad9a"]])

export default __exports__